/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Component } from "react";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import moment from "moment";
import "../../css/pages/home.css";
import "../../css/pages/customers.css";
import { Link } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import undrawSearch from "../../assets/svgs/undraw_search_re_ttoj.svg";
import SideNav from "../components/SideNav";
import TopNav from "../components/TopNav";
import { fetchCreditLoans, fetchLoanStats } from "../actions/p2p";
import Pagination from "../components/Pagination";
import NoData from "../../assets/svgs/undraw_No_data_re_kwbl.svg";
// import MoreIcon from '';
import LoanDetails from "../components/modals/LoanDetails";
import CreateLoan from "../components/modals/CreateLoan";
import EditLoan from "../components/modals/EditLoan";
import CancelLoan from "../components/modals/CancelLoan";
import AcceptLoan from "../components/modals/AcceptLoan";
import CreateLoanMultiple from "../components/modals/CreateLoanMultiple";
import CreateLoanSingle from "../components/modals/CreateLoanSingle";
import MoreToggle from "../components/MoreToggle";
import { fillUser } from "../actions/account";
import ApproveLoan from "../components/modals/ApproveLoan";

class CreditLine extends Component {
  constructor(props) {
    super(props);
    this.state = {
      records: [],
      loan_arr: [],
      selected_loans: {},
      query: "",
      current_page: new URLSearchParams(props.location.search).get("page") || 1,
      status_id:
        new URLSearchParams(props.location.search).get("status_id") || "",
      limit: 10,
      create: false,
      edit: false,
      cancel: false,
      single: false,
      multiple: false,
      showModal: false,
      pin: '',
      id:''
    };
  }

  handleDisburse = (loanId) => {
   
    // this.setState({
    //   showModal: true,
    //   id: loanId,
    // });
    this.setState({
        showModal: true,
        id: loanId,
      }, () => {
        console.log("Selected loan ID:", this.state.id);
      });
   
  };


  closeModal = () => {
    this.setState({ showModal: false });
  };

  componentDidMount() {
    try {
      fetchLoanStats()
        .then(({ data }) =>
          this.setState({
            total_loans: data.reduce((a, b) => a + (b.count || 0), 0),
            stats: data.reduce((acc, curr) => {
              acc[curr.status.status] = {
                status_id: curr.status_id,
                count: curr.count,
                principal: curr.principal,
                amount_due: curr.amount_due,
                loan_amount: curr.loan_amount,
              };
              return acc;
            }, {}),
          })
        )
        .catch(() =>
          toast.error("An error occured fetching loans stats on your account.")
        );
    } catch (error) {
      console.log(error);
    }
  }

  handlePageChange = (data) => {
    const { limit, query } = this.state;
    fetchCreditLoans(
      data.currentPage,
      query,
      "created_on",
      "DESC",
      limit,
      "",
      "",
      "",
      this.state.status_id
    ).then(({ data: { records, page_info } }) =>
      this.setState({
        records,
        current_page: page_info.page,
        total: page_info.total,
      })
    );
  };

  fetchNextDueDate = (schedules) => {
    schedules = schedules.filter((schedule) => {
      const start = moment(new Date());
      const end = moment(new Date(schedule?.due_date));
      const duration = moment.duration(end.diff(start));
      if (duration.asMinutes() >= 0) {
        return true;
      }
      return false;
    });
    if (schedules.length > 0) {
      return schedules[0].due_date;
    }
    return "-";
  };

  onSearch = (e) => {
    const { limit } = this.state;
    this.setState({ query: e.currentTarget.value });
    fetchCreditLoans(
      e.currentPage,
      e.currentTarget.value,
      "created_on",
      "DESC",
      limit
    ).then(({ data: { records, page_info } }) =>
      this.setState({
        records,
        current_page: page_info.page,
        total: page_info.total,
      })
    );
  };

  DropDownItems = (loan) => {
    const { history } = this.props;
    return (
      <Dropdown>
        <Dropdown.Toggle as={MoreToggle} />
        <Dropdown.Menu>
          <Link
            className="dropdown-item"
            onClick={() => history.push(`customers/${loan?.user?.id}`)}
          >
            View Customer
          </Link>
          <Link
            className="dropdown-item"
            onClick={() => this.setState({ edit: loan })}
          >
            Edit
          </Link>
          <Link
            className="dropdown-item"
            onClick={() => this.setState({ cancel: loan })}
          >
            Cancel
          </Link>
        </Dropdown.Menu>
      </Dropdown>
    );
  };

  render() {
    const {
      records,
      selected_loans,
      loan_arr,
      action,
      loading,
      loan,
      total,
      current_page,
      limit,
      create,
      edit,
      cancel,
      single,
      multiple,
      stats,
      total_loans,
      showModal,
      id
    } = this.state;

    const { history, user } = this.props;
    return (
      <>
        <SideNav page="Credit Line" />
        <main className="body-main">
          <div className="body-main__container">
            <TopNav page="Credit Line" />

            {/* <div className="default-card home__stats">
              <div className="row">
                <Link
                  onClick={() => {
                    history.push("/loans");
                    window.location.reload(false);
                  }}
                  style={{ textDecoration: "none", cursor: "pointer" }}
                  className="col-12 col-md-2 home__stats--group"
                >
                  <div className="home__stats--group-content">
                    <p>TOTAL</p>
                    <h3>
                      {Number(total_loans || 0).toLocaleString(undefined, {
                        minimumFractionDigits: 0,
                      })}
                    </h3>
                  </div>
                </Link>
                <Link
                  onClick={() => {
                    const statuses = [
                      stats?.["GUARANTOR VALIDATED"]?.status_id,
                      stats?.["PENDING GUARANTOR'S APPROVAL"]?.status_id,
                      stats?.["PENDING LENDER'S APPROVAL"]?.status_id,
                      stats?.["PENDING BORROWER'S APPROVAL"]?.status_id,
                    ];
                    history.push(
                      `/loans?status_id=${statuses.filter(Boolean).join()}`
                    );
                    window.location.reload(false);
                  }}
                  style={{ textDecoration: "none", cursor: "pointer" }}
                  className="col-12 col-md-3 home__stats--group"
                >
                  <div className="home__stats--group-content">
                    <p>AWAITING APPROVALS</p>
                    <h3>
                      {Number(
                        stats?.["GUARANTOR VALIDATED"]?.count ||
                          0 + stats?.["PENDING GUARANTOR'S APPROVAL"]?.count ||
                          0 + stats?.["PENDING LENDER'S APPROVAL"]?.count ||
                          0 + stats?.["PENDING BORROWER'S APPROVAL"]?.count ||
                          0
                      ).toLocaleString(undefined, { minimumFractionDigits: 0 })}
                    </h3>
                  </div>
                </Link>
                <Link
                  onClick={() => {
                    const statuses = [stats?.RUNNING?.status_id];
                    history.push(
                      `/loans?status_id=${statuses.filter(Boolean).join()}`
                    );
                    window.location.reload(false);
                  }}
                  style={{ textDecoration: "none", cursor: "pointer" }}
                  className="col-12 col-md-2 home__stats--group"
                >
                  <div className="home__stats--group-content">
                    <p>RUNNING</p>
                    <h3>
                      {Number(stats?.RUNNING?.count || 0).toLocaleString(
                        undefined,
                        { minimumFractionDigits: 0 }
                      )}
                    </h3>
                  </div>
                </Link>
                <Link
                  onClick={() => {
                    const statuses = [stats?.SETTLED?.status_id];
                    history.push(
                      `/loans?status_id=${statuses.filter(Boolean).join()}`
                    );
                    window.location.reload(false);
                  }}
                  style={{ textDecoration: "none", cursor: "pointer" }}
                  className="col-12 col-md-2 home__stats--group"
                >
                  <div className="home__stats--group-content">
                    <p>SETTLED</p>
                    <h3>
                      {Number(stats?.SETTLED?.count || 0).toLocaleString(
                        undefined,
                        { minimumFractionDigits: 0 }
                      )}
                    </h3>
                  </div>
                </Link>
                <Link
                  onClick={() => {
                    const statuses = [stats?.["PAST DUE"]?.status_id];
                    history.push(
                      `/loans?status_id=${statuses.filter(Boolean).join()}`
                    );
                    window.location.reload(false);
                  }}
                  style={{ textDecoration: "none", cursor: "pointer" }}
                  className="col-12 col-md-3 home__stats--group"
                >
                  <div className="home__stats--group-content">
                    <p>PAST DUE</p>
                    <h3>
                      {Number(stats?.["PAST DUE"]?.count || 0).toLocaleString(
                        undefined,
                        { minimumFractionDigits: 0 }
                      )}
                    </h3>
                  </div>
                </Link>
              </div>
            </div> */}

            <div className="row">
              <div className="col">
                {!records.length && (
                  <div
                    className="empty-state empty-state-loans"
                    hidden={records.length}
                  >
                    <img src={NoData} alt="Illustration for empty state" />
                    <h3 className="empty-state__title">
                      There are no loans yet.
                    </h3>
                    <p className="empty-state__subtext">
                      Loans will show up here once you start lending.
                    </p>
                    <Link
                      type="button"
                      to="#"
                      onClick={() => this.setState({ create: true })}
                      className="btn btn-primary empty-state__btn"
                    >
                      Create Loan
                    </Link>
                  </div>
                )}

                {/* {console.log("Chekcing lonad",records)} */}

                <div className="filled--state loans" hidden={!records.length}>
                  <div className="filter-and-search">
                    <div className="filter-box d-flex">
                      <div className="search-box">
                        <input
                          type="search"
                          className="form-control"
                          placeholder="Search..."
                          onInput={(e) =>
                            e.currentTarget.value === "" && this.onSearch(e)
                          }
                          onKeyDown={(e) =>
                            e.key === "Enter" && this.onSearch(e)
                          }
                        />
                      </div>
                    </div>
                    <div className="filter-and-search d-flex justify-content-end">
                      {/* {Object.keys(selected_loans).length !== 0 && (
                        <div className="button-box me-lg-3">
                          <button
                            type="button"
                            className="btn btn-primary"
                            disabled={!!loading}
                            onClick={() => {
                              this.setState({ loading: 'Processing' }, async () => {
                                this.setState({
                                  loan_arr: Object.keys(Object.fromEntries(
                                    Object.entries(selected_loans).filter(([key, value]) => value === true)) ),
                                });
                                this.setState({ action: 'accept' });
                              });
                            }}>
                            {loading || 'Accept Loans'}
                          </button>
                        </div>
                      )} */}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      <div className="card default-card page-table">
                        <div className="empty-state no-result" hidden>
                          <img
                            src={undrawSearch}
                            alt="Illustration for search"
                          />
                          <h3 className="empty-state__title">
                            No results found.
                          </h3>
                          <p className="empty-state__subtext">
                            Please check your spelling or try searching for
                            something different.
                          </p>
                        </div>

                        <div className="table-responsive">
                          <table className="table table-hover">
                            <thead>
                              <tr>
                                <th className="borrower_id">Borrower ID</th>
                                <th className="name">Name</th>
                                <th className="name">Company Name</th>
                                <th className="interest_rate">Interest Rate</th>
                                <th className="status">Status</th>
                                <th className="date-time">Created date</th>
                                <th className="more-action"></th>
                              </tr>
                            </thead>
                            <tbody>
                              {records.map((loan) => (
                                <tr
                                  key={loan.id}
                                  role="button"
                                  onClick={() =>
                                    history.push(`loans/${loan.id}`)
                                  }
                                >
                                  <td className="borrower_id text-nowrap">
                                    {loan?.user?.id || "-"}
                                  </td>
                                  <td className="name text-nowrap">
                                    {loan?.user?.customer_name}
                                  </td>
                                  <td className="name text-nowrap">
                                    {loan?.organization?.name}
                                  </td>
                                  <td className="loan_amount text-nowrap">
                                    {Number(loan.amount || 0).toLocaleString(
                                      undefined,
                                      { minimumFractionDigits: 2 }
                                    )}
                                  </td>
                                  <td className="status text-nowrap">
                                    {loan?.status}
                                  </td>
                                  <td className="date-time text-nowrap">
                                    <span className="date">
                                      {moment(loan?.created_on).format(
                                        "MMM DD, YYYY, h:mm:ss a"
                                      )}
                                    </span>
                                  </td>
                                  <td
                                    className="more-action"
                                    onClick={(e) => e.stopPropagation()}
                                  >
                                    <div
                                      className="text-green"
                                      style={{
                                        color: "white",
                                        backgroundColor: "lightBlue",
                                        padding: 4,
                                        borderRadius: 10,
                                        textAlign: "center",
                                        fontSize: 16,
                                      }}
                                      onClick={() =>
                                        this.handleDisburse(loan.id)
                                      }
                                    >
                                      Disburse
                                    </div>
                                    {/* {this.DropDownItems(loan)} */}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <Pagination
                        totalRecords={total}
                        pageLimit={limit}
                        pageNeighbours={1}
                        onPageChanged={this.handlePageChange}
                        initialPage={current_page}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
        {/* <LoanDetails
          visible={!!loan}
          data={loan}
          onClose={() => this.setState({ loan: null })} /> */}

<ApproveLoan
  visible={!!showModal}
  data={this.state.id}
  onSubmit={this.handleOnSubmit}
  onClose={() => this.setState({ showModal: null })}
/>




        {/* <CancelLoan
          visible={cancel}
          data={cancel}
          onClose={() => this.setState({ cancel: null })} /> */}
        {/* <CreateLoan
          visible={create}
          history={this.props.history}
          onSubmit={({ option }) => {
            this.setState({ create: false, [option]: true });
          }}
          onClose={() => this.setState({ create: false })} /> */}
       
        {/* <CreateLoanMultiple
          visible={multiple}
          onSubmit={() => this.handlePageChange({})}
          onClose={() => this.setState({ multiple: false })} /> */}
        {/* <AcceptLoan
          visible={action === 'accept'}
          data={loan_arr.map(id => ({ id }))}
          onClose={() => this.setState({ action: null })} /> */}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.account?.user || {},
});

const mapDispatchToProps = { fillUser };

export default connect(mapStateToProps, mapDispatchToProps)(CreditLine);
